<template>
  <app-slide>
    <article class="layout" ref="start" id="start">
        <div class="container" id="artwork-00">
          <div class="row">
              <div class="col-xs-12 text-content margin-bottom-4">
                  <div class="waypoint-block" data-work="00" v-if="artist"></div>
                  <h2 class="margin-bottom-2">{{artist.title}}</h2>
                  <p v-if="!isInFavs" @click="addArtist(artist)">{{getTranslation('save-this-artist')}}</p>
                  <p v-if="isInFavs" @click="removeArtist(artist)">{{getTranslation('remove-from-saved')}}</p>
                  <app-meta-artist :content="artist"></app-meta-artist>
                  <div v-html="artist.biography"></div>
                  <div class="artwork-container row" v-for="artwork in artist.artworks" :key="artwork.id" :id="'artwork-' + artwork.code" :ref="'artwork-' + artwork.code">
                  <div class="waypoint-block" :data-work="artwork.code"></div>
                  <div class="col-xs-12">
                    <h2 class="margin-top-1 margin-bottom-2 italic">{{artwork.title}}</h2>
                      <div class="artwork-holder" v-for="image in artwork.images" :key="image.id">
                      <img :src="image.url" :alt="artwork.title" class="img-responsive margin-bottom-1" @load="setupWayPoints"/>
                       <dl v-if="image.title" class="">
                        <dt>{{getTranslation('image')}}</dt>
                        <dd>{{image.title}}</dd>
                      </dl>
                      <dl v-if="image.photo">
                        <dt>{{getTranslation('photo')}}</dt>
                        <dd>{{image.photo}}</dd>
                      </dl>
                    </div>
                    <app-meta-artwork :artwork="artwork" :artistCode="artist.code"></app-meta-artwork>
                    <div v-if="artwork.body" class="margin-top-3">
                      <div v-html="artwork.body"></div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
    </article>
  </app-slide>
</template>


<script>
  import {store} from '../store/store'
  import MetaArtist from '../components/MetaArtist'
  import MetaArtwork from '../components/MetaArtwork'
  import MapArtwork from '../components/MapArtwork'
  import appSlide from '../transitions/AppSlide'
  import VueScrollTo from 'vue-scrollto'
  import mixinLanguages from '../mixins/Language'
  // import HomeRiboca from '../components/HomeRiboca'
  // import slide from '../mixins/PageSlide'
  export default {
    name: 'artistDetail',
    components: {
      appMetaArtwork: MetaArtwork,
      appMetaArtist: MetaArtist,
      appMapArtwork: MapArtwork,
      appSlide:appSlide
    },
    props: ['slug','url'],
    mixins: [mixinLanguages],
    data() {
      return {
        artist:'',
        positions:[],
        currentSlug:'',
        oldLoc:'',
        intersectionOptions: {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          thresholds: [1]
        } 
      }
    },
    mounted () {
      this.getArtist();
      let thisUrl = this.slug + '/' + this.url;
      store.dispatch('setDestUrl', thisUrl);
      store.dispatch('setDestChange', false);
      if (this.url != '00') {
          let vm = this;
          setTimeout(function(){ 
            vm.scrollToWork(vm.url);
          }, 1000);
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    computed:{
      lang() { 
        return this.$store.state.langUrl;
      },
      destChange() {
        return this.$store.state.destChange;
      },
      destUrl() {
        return this.$store.state.destUrl;
      },
      favArtists() { 
        return this.$store.state.favArtists;
      },
      isInFavs() {
        let vm = this;
        let compareList = this.$store.getters.getFavArtists.filter(function (item) {
          return item.code.match(vm.artist.code);
        });
        if (compareList.length) {
          return true;
        } else {
          return false;
        }
      }
    },
    watch: {
      lang(newValue) {
        this.getArtist();
      },
      destChange(newValue) {
        let newVal = this.$store.state.destUrl.substr(3);
        console.log('dest changed' + newVal);
        if (newValue == true) {
          this.scrollToWork(newVal)
        }
      }
    },
    methods: {
      addArtist(obj) {
        store.commit('addFavArtists', obj);
        // store.commit('addFavArtists', {title:'Alex',id:1});
      },
      removeArtist(obj) {
        let index = this.$store.getters.getFavArtists.findIndex(p => p.code == obj.code);
        store.commit('removeFavArtists', index);
      },
      setupWayPoints() {
        this.positions = [];
        var wayGroups = document.getElementsByClassName("waypoint-block");
        for (let i=0; i<wayGroups.length;i++) {
          let rect = wayGroups[i].getBoundingClientRect();
          let top = rect.top + window.scrollY - 100;
          let workCode = wayGroups[i].dataset.work;
          this.positions.push([top, workCode]);
        }
      },
      getArtist() {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/mobile/v1/artists/' + this.slug + '.json';
        this.$http.get(url).then((response) => {
          this.artist = response.data.data[0];
        })
      },
      // initScroll() {
      //   if (this.url != '00') {
      //     this.scrollToWork(this.url);
      //   }
      // },
      scrollToWork(target) {
        // console.log('scroll to work');
        // let tg = '#artwork-' + target;
     
        // console.log(tg);
        // var options = {
        //   container: '#start',
        //   easing: 'ease-in',
        //   offset: -100,
        //   cancelable: true,
        //   x: false,
        //   y: true
        // };
        // VueScrollTo.scrollTo(tg, 500, options);
        // let element = this.$refs[rg];
        let rg = 'artwork-' + target;
        console.log(rg);
        let element = document.getElementById(rg);
        let top = element.offsetTop + window.scrollY;
        window.scrollTo(0, top);
        store.dispatch('setDestChange', false);
      },
      handleScroll (event) {
        let i = 0;
        let scrollY = window.scrollY;
        for (i=0;i<this.positions.length;i++) {
          if (scrollY > this.positions[i][0]) {
            let shortcut = this.artist.code + '/' + this.positions[i][1]
            if (shortcut != this.currentSlug) {
              this.currentSlug = shortcut;
              store.dispatch('setDestUrl', shortcut);
            }
          } 
        }
      }
    }
  }
</script>

<style lang="scss">
  .waypoint-block {
    position: relative;
    width:100%;
    height: 10px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/ArtistDetail.vue